import { render, staticRenderFns } from "./travelDetailTable.vue?vue&type=template&id=0a6c888e&scoped=true&"
import script from "./travelDetailTable.vue?vue&type=script&lang=js&"
export * from "./travelDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./travelDetailTable.vue?vue&type=style&index=0&id=0a6c888e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c888e",
  null
  
)

export default component.exports